export function determineLocation() {
    switch (window.location.hostname) {
        case 'localhost':
            return 'http://localhost:5001';
        default:
            return 'https://api.fylepro.com'
    }
}